import {
  BLUE_PRIMARY,
  ERROR_COLOR,
  GREEN_PRIMRY,
  ORANGE_COLOR,
  WHITE,
} from "../../utils/const";
import SimpleTable from "../CustomTable/SimpleTable";

const EventsTable = ({ events }) => {
  const eventsHeader = [
    { title: "رویداد", key: "eventName" },
    { title: "کد رویداد", key: "eventCode" },
    { title: "اهمیت رویداد", key: "eventPriority" },
  ];
  const evetsTabeleData = [];
  const renderPriority = (priority) => {
    if (priority === "H") {
      return (
        <span
          style={{
            backgroundColor: ERROR_COLOR,
            padding: " 0 5px",
            borderRadius: "4px",
            color: WHITE,
          }}
        >
          زیاد
        </span>
      );
    } else if (priority === "M") {
      return (
        <span
          style={{
            backgroundColor: ORANGE_COLOR,
            padding: " 0 5px",
            borderRadius: "4px",
            color: WHITE,
          }}
        >
          متوسط
        </span>
      );
    } else {
      return (
        <span
          style={{
            backgroundColor: GREEN_PRIMRY,
            padding: " 0 5px",
            borderRadius: "4px",
            color: WHITE,
          }}
        >
          کم
        </span>
      );
    }
  };
  events.value.forEach((event) => {
    evetsTabeleData.push({
      eventName: event.event_type_keyword,
      eventCode: event.event_type_code,
      eventPriority: renderPriority(event.event_type_importance),
    });
  });

  return (
    <>
      <SimpleTable
        hasIndex={true}
        hasLink={false}
        darkHeader={true}
        data={evetsTabeleData}
        header={eventsHeader}
      />
    </>
  );
};
export default EventsTable;
